import { selector } from "recoil";
import { getNumber } from "../../functions/utils";
import { floorState } from "./floorState";


export const leafletZoomIconHideState = selector<number>({
    key: "leafletZoomIconHideState",
    get: ({ get }) => {
        const floor = get(floorState);
        return getNumber(floor?.zoom_icon_hide, -1);
    },
});
